// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	if (fields.futur_fee_premie.length === 0 ||
		fields.futur_fee_kapital.length === 0 ||
		fields.futur_fee_fast.length === 0)
	{
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Fees/Fees.fulfillment.js